import { ComponentProps } from "react";
import clsx from "clsx";

export function ColorButton({ children, className, ...rest }: ComponentProps<"button">) {
  return (
    <button
      className={clsx("size-6 cursor-pointer rounded transition-all hover:scale-110 hover:opacity-85", className)}
      {...rest}
    >
      {children}
    </button>
  );
}
